module.exports = __webpack_public_path__ + "static/serenity_forge-e2fe6d8edc34d7dc3911ff1263eb74e8.webp";